import React from 'react'
import About from './About'
import Why from '../Why/Why'
import Advantage from '../Advantage/Advantage'
import Amenities from '../Amenities/Amenities'
import Location from '../Location/Location'
const Aboutus = () => {
  return (
    <>
    <div className='aboutus'>
      <About/>
      <Advantage/> 
      <Why/>
      <Amenities/>
      <Location/>
      </div> 
    </>
  )
}

export default Aboutus